import _regeneratorRuntime from "/root/app/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}
/* eslint prettier/prettier: 0 */


import { postData, usePost } from '../fetch';
import { API_VERSION, API_URL } from './constants';
/**
 * Generates the URL and POST body needed to hit the `custom/filters` endpoint
 */

function getWidgetFilterOptionsRESTDetails(_ref) {
  var accountId = _ref.accountId,
      dashboardVersionId = _ref.dashboardVersionId,
      _ref$filters = _ref.filters,
      filters = _ref$filters === void 0 ? [] : _ref$filters,
      widgetId = _ref.widgetId;
  var url = "".concat(API_URL, "/v").concat(API_VERSION, "/custom/filters/").concat(accountId, "/report/").concat(dashboardVersionId, "/widget/").concat(widgetId);
  var body = {
    activeFilters: filters
  };
  return {
    url: url,
    body: body
  };
}
/**
 * Use this method to get the `custom/filters` response from a non-hook scenario (like save time validation)
 */


export function getWidgetFilterOptions(_x) {
  return _getWidgetFilterOptions.apply(this, arguments);
}
/**
 * Use this method to get the `custom/filters` response in a hook scenario (for the filter list loadable)
 */

function _getWidgetFilterOptions() {
  _getWidgetFilterOptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var _getWidgetFilterOptio2, url, body;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _getWidgetFilterOptio2 = getWidgetFilterOptionsRESTDetails(params), url = _getWidgetFilterOptio2.url, body = _getWidgetFilterOptio2.body;
            _context.next = 4;
            return postData(url, JSON.stringify(body));

          case 4:
            return _context.abrupt("return", _context.sent);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", _context.t0);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));
  return _getWidgetFilterOptions.apply(this, arguments);
}

export function useWidgetFilterOptions(params) {
  var _getWidgetFilterOptio = getWidgetFilterOptionsRESTDetails(params),
      url = _getWidgetFilterOptio.url,
      body = _getWidgetFilterOptio.body;

  return usePost(url, body, 'useWidgetFilterOptions');
}